import PropTypes from 'prop-types';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function Column(_props) {
    return null;
}
Column.defaultProps = {
    width: 100,
};
Column.propTypes = {
    align: PropTypes.oneOf(['left', 'center', 'right']),
    verticalAlign: PropTypes.oneOf(['top', 'middle', 'bottom']),
    width: PropTypes.number,
    fixed: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['left', 'right'])]),
    resizable: PropTypes.bool,
    sortable: PropTypes.bool,
    flexGrow: PropTypes.number,
    minWidth: PropTypes.number,
    colSpan: PropTypes.number,
    treeCol: PropTypes.bool,
    onResize: PropTypes.func,
    render: PropTypes.func,
};
export default Column;
